module.exports = __webpack_public_path__ + "img/finscraper-min.9dfd1102.jpg";